import { redact } from "./redact";
import { truncateChars } from "./text";

/** Cap on the logged excerpt. Provider errors are a short JSON object; an
 *  intermediary failing instead can return a whole HTML page, and only the
 *  first line of that says anything. */
const ERROR_DETAIL_MAX = 500;

/**
 * Make a provider's error text safe and useful to log. Shared by every client
 * that logs a third-party error body (the transcription clients, the Fortnox
 * token endpoint), so there is one policy for what that text may carry into a
 * log line.
 *
 * Redacted because the body is third-party text that can quote the request back
 * (an auth header echoed into an error is exactly the shape `redact` exists
 * for), whitespace-collapsed so an HTML page stays one line, and clipped with
 * `truncateChars` so the cut cannot split a surrogate pair and take the whole
 * `messages` INSERT down with it.
 */
export const describeErrorBody = (body: string): string | undefined => {
  // Bounded before the regex passes: only the head survives the clip anyway.
  const collapsed = redact(truncateChars(body, ERROR_DETAIL_MAX * 4).replace(/\s+/g, " ").trim());
  return collapsed ? truncateChars(collapsed, ERROR_DETAIL_MAX) : undefined;
};
